import { Box } from "@mui/material";
import { JSX } from "react";
import { FeedBoxPanels, FeedDrawerPanels } from "views/knowledge/feed/components/FeedBoxPanels";
import { OutsideRightPanel } from "views/knowledge/publication/pages/components/OutsideRightPanel";

////////////////////////////////////////////////////////////////////////////////

type MainPanelBreakpoints = "xs" | "md" | "lg" | "xl";

interface PageContentBoxProps {
    id?: string;
    content?: JSX.Element;
    rightPanel?: React.ReactElement[];
    openRightPanel: boolean;
    maxWidth: MainPanelBreakpoints;
    onCloseRighPanel: () => void;
}

export const PublicationContentBox = ({ id, content, maxWidth = "lg", rightPanel, openRightPanel, onCloseRighPanel }: PageContentBoxProps) => {
    return (
        <Box id={id} sx={theme => ({ display: "flex", gap: 2, marginTop: theme.spacing(.5) })}>
            <Box sx={(theme) => ({
                maxWidth: theme.breakpoints.values[maxWidth],
                margin: "0 auto",
                flexGrow: 1
            })}>
                {content}
            </Box>
            {
                rightPanel &&
                <Box
                    sx={{
                        display: { xs: "none", md: "block" },
                        position: "sticky",
                        alignSelf: "start",
                        top: 58,
                    }}
                >
                    <FeedBoxPanels>
                        {rightPanel}
                    </FeedBoxPanels>
                </Box>
            }
            {
                openRightPanel &&
                <OutsideRightPanel
                    onClose={onCloseRighPanel}
                    content={
                        <FeedDrawerPanels>
                            {rightPanel}
                        </FeedDrawerPanels>
                    }
                />
            }
        </Box>
    );
};